var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'dark-mode': _vm.isDarkMode, 'mobile-view': _vm.isMobileView },attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"main-container"},[(_vm.showSidebar)?_c('Sidebar'):_vm._e(),_c('div',{staticClass:"content-container",class:{ 'full-width': !_vm.showSidebar }},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }